var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashIcon = function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M5.32 1.288A1 1 0 0 1 6.23.704h3.924c.39 0 .746.227.908.584l.26.454h3.113c.551 0 1.038.486 1.038 1.038 0 .583-.487 1.037-1.038 1.037H1.98A1.025 1.025 0 0 1 .942 2.78c0-.552.454-1.038 1.038-1.038h3.114zm9.114 3.567-.713 10.995c-.033.843-.714 1.459-1.557 1.459H4.218c-.843 0-1.524-.616-1.557-1.46l-.68-10.994z"
  })));
};
export default SvgTrashIcon;